import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, UpdateAuthorizedIpsDialogueHandler } from './types';
import UpdateAuthorizedIpsContext from './UpdateAuthorizedIpsContext';

const { ConfirmationDialogue } = vp;

type AuthorizedIpsDialogueProps = {
  handleDialogue: DialogueHandler<UpdateAuthorizedIpsDialogueHandler>;
};

type FC = FunctionComponent<AuthorizedIpsDialogueProps>;

const UpdateAuthorizedIpsDialogue: FC = ({ handleDialogue }: AuthorizedIpsDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(UpdateAuthorizedIpsContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });
  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('AuthorizedIps.Dialogue.errorTitle', { defaultValue: 'Error! The Authorize IP Addresses were not updated.' })}
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: t('AuthorizedIps.Dialogue.back', { defaultValue: 'Back' }),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('AuthorizedIps.Dialogue.successTitle', { defaultValue: 'Success! The Authorize IP Addresses were updated.' })}
          status="success"
          subTitle={t('AuthorizedIps.Dialogue.successSubTitle', { defaultValue: 'Navigate back to Authorize IP Addresses.' })}
          confirm={{
            label: t('AuthorizedIps.Dialogue.backToAuthorizedIps', { defaultValue: 'Back to Authorize IP Addresses' }),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdateAuthorizedIpsDialogue;
